import { Component, OnInit, Input, ContentChild, TemplateRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'pds-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputComponent)
    }
  ]
})

export class InputComponent implements OnInit, ControlValueAccessor {

  @Input() className: Array<string>;
  @Input() inputType?: string;
  @Input() inputPlaceholder?: string;
  @ContentChild('iconRight', { static: false }) iconRightTemplateRef: TemplateRef<any>;
  public value: string;
  public localValue: string;
  public localPlaceholder: string;
  public disabled: boolean;
  public classValue = '';
  public localReadOnly = false;
  public onChange = (_: any) => { };
  public onTouched = () => { };

  constructor() { }

  ngOnChanges() {
    this.classValue = this.className.reduce((acc, currentValue) => `${acc} pds-input--${currentValue}`, '');
    if (this.inputPlaceholder) {
      this.localPlaceholder = this.inputPlaceholder;
    }
  }

  ngOnInit(): void {
    if (this.inputPlaceholder) {
      this.localPlaceholder = this.inputPlaceholder;
    }
  }

  onInput(value: string) {
    this.value = value;
    this.onTouched();
    this.onChange(this.value);
  }
  writeValue(value: any): void {
    this.value = value || '';
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }
}
